import { OrdersList } from 'components/orders/OrdersList/OrdersList'
import { useParams } from 'react-router-dom'

export const SellerOrders: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <OrdersList sellerId={id as string} />
}